export const GATEWAY_PROXY_PREFIX = '/platform/gateway-proxy-v2';

export const NAVIGATION_ENDPOINTS = {
  V1_NAVIGATION: `${GATEWAY_PROXY_PREFIX}/v1/navigation`,
  V1_IDENTITY: `${GATEWAY_PROXY_PREFIX}/v1/identity`,
  V1_UNIVERSAL_IDENTITY: `${GATEWAY_PROXY_PREFIX}/v1/navigation/universal-identity`,
  V1_PREFERENCE_NAVIGATION: `${GATEWAY_PROXY_PREFIX}/v1/preference/navigation`,
  V1_ORDERS_CURRENCIES: `${GATEWAY_PROXY_PREFIX}/v1/orders/currencies`,
  V1_TENANT_CONFIG: `${GATEWAY_PROXY_PREFIX}/v1/tenant/config`,
  GENESIS_USER_INFO: `${GATEWAY_PROXY_PREFIX}/genesis/user/info`,
  WORKFLOW_TASKS: `${GATEWAY_PROXY_PREFIX}/workflows/tasks`,
  REVPRO_OAUTH_TOKEN: '/revpro/api/revpro/public/oauth/refreshtoken',
  SEARCH_STATUS: `${GATEWAY_PROXY_PREFIX}/search/status`,
  SEARCH_COUNT: `${GATEWAY_PROXY_PREFIX}/search/search-count`,
  SEARCH_METADATA: `${GATEWAY_PROXY_PREFIX}/search/metadata`,
  SEARCH_QUICK_SEARCH: `${GATEWAY_PROXY_PREFIX}/search/quick-search`,
  ZSESSION_REFRESH: '/platform/api/zsession-refresh',
  ORG_PICKER_DATA: `${GATEWAY_PROXY_PREFIX}/v1/multi-organizations/org-picker-data`,
  USER_PREFERENCES: `${GATEWAY_PROXY_PREFIX}/v1/preference/ui`,
  GET_COPILOT_SUPPORT_CONVERSATIONS: `${GATEWAY_PROXY_PREFIX}/copilot/support/conversations`,
  COPILOT_SUPPORT_CONVERSATIONS: `${GATEWAY_PROXY_PREFIX}/copilot/support/conversations/stream`,
  SUPPORT_REQUEST_CREATE: `${GATEWAY_PROXY_PREFIX}/support/request/create`,
  COPILOT_SUPPORT_QUOTA: `${GATEWAY_PROXY_PREFIX}/copilot/support/quota`,
  SUPPORT_REQUEST_ACCESS_TOKEN: `${GATEWAY_PROXY_PREFIX}/support/request/access-token`,
  SUPPORT_REQUEST_SEARCH: `${GATEWAY_PROXY_PREFIX}/support/request/search`,
  TENANT_METADATA: `${GATEWAY_PROXY_PREFIX}/tenant-registry/info/tenantsServiceInfo`,
  ORGANIZATION_LIST: `${GATEWAY_PROXY_PREFIX}/support/request/organizationMemberships`,
  TAGS_LIST: `${GATEWAY_PROXY_PREFIX}/support/request/tags`,
  CUSTOM_OBJECTS: `${GATEWAY_PROXY_PREFIX}/objects/definitions/default`,
  TRUST_INCIDENTS: `${GATEWAY_PROXY_PREFIX}/support/private-trust/incidents`,
  COPILOT_SUPPORT_FEEDBACK: `${GATEWAY_PROXY_PREFIX}/copilot/support/conversations`,
  APPSMITH_SOLUTIONS: `${GATEWAY_PROXY_PREFIX}/extensions/store/allurls`,
  REVENUE_LIGHTHOUSE_PREFERENCE:
    '/revenue/api/revpro/revapp/secure/common/configuration?key=UI_PREFERENCE',
  REVPRO_LIGHTHOUSE_PREFERENCE:
    '/revpro/api/revpro/revapp/secure/common/configuration?key=UI_PREFERENCE',
};

export const enum LEGACY_NAVIGATION_ENDPOINTS {
  PLATFORM_STATE = '/platform/api/state',
  PLATFORM_IDENTITY = '/platform/api/identity',
}

export function getZuoraAiSharedChatUrl(shareId: string): string {
  if (typeof window === 'undefined') {
    return '';
  }
  return `${window.location.origin}/platform/apps/zuora-ai/chat/share/${shareId}`;
}
